import * as React from "react";


interface IProps {
    className?: string,
    title: string,
}


export class PageTitle extends React.Component<IProps> {

    constructor(props:IProps) {
        super(props);
    }

    public render() {
        return (
            <div className={this.props.className}>
                <h1>{this.props.title}</h1>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/navigation/PageTitle.tsx